import { createContext } from 'react';
import { LanguageType } from './api/responses';

export const LanguageContext = createContext<LanguageType[]>([]);
